import React from 'react';
import styled from 'styled-components';

export const Step2 = ({ dispatch, packageInfo }) => {
	window.history.pushState('', '', '/checkout/ekstri');

	const SelectCard = styled.div`
		white-space: pre-wrap;
		padding: 1.5rem;
		margin: 1rem 1rem 1rem 1rem;
		opacity: ${(props) => (props.isAdded ? 0.6 : 1)};

		background: #ffffff;
		box-shadow: 0px 0px 30px rgba(51, 1, 109, 0.1);
		border-radius: 8px;

		@media screen and (min-width: 991px) {
			margin: 1rem 1rem 1rem 0rem;
		}
	`;
	return (
		<>
			<h2 className="mb-5">Конфигурирай</h2>
		</>
	);
};

